import React from 'react'
import AccountManager from '../managers/account'
import { useApplicationState } from '../state'

import { isEmpty } from 'lodash'

const PREFERENCES_FAVORITE_SPORTS = 'favS'
const PREFERENCES_FAVORITE_TOURNAMENTS = 'favT'
const PREFERENCES_FAVORITE_EVENTS = 'favE'
const PREFERENCES_FAVORITE_MARKETS = 'favM'

function createFavoritesExtract (favoriteKey) {
  return function useFavorites () {
    const {
      auth: {
        preferences
      }
    } = useApplicationState()

    const favorites = React.useMemo(
      () => {
        if (isEmpty(preferences[favoriteKey])) {
          return []
        }

        return preferences[favoriteKey]
      },
      [preferences]
    )

    const setFavorites = React.useCallback(
      favoriteItemIds => {
        return AccountManager.setClientPreferences({
          ...preferences,
          [favoriteKey]: favoriteItemIds
        })
      },
      [favorites, preferences]
    )

    return [
      favorites,
      setFavorites
    ]
  }
}

export const useFavoriteSports = createFavoritesExtract(PREFERENCES_FAVORITE_SPORTS)
export const useFavoriteTournaments = createFavoritesExtract(PREFERENCES_FAVORITE_TOURNAMENTS)
export const useFavoriteEvents = createFavoritesExtract(PREFERENCES_FAVORITE_EVENTS)
export const useFavoriteMarkets = createFavoritesExtract(PREFERENCES_FAVORITE_MARKETS)
